import { asyncLoader } from '../shared/util/components';

export const System = asyncLoader(() => import(/* webpackChunkName: "system" */ './system'));
export const Developer = asyncLoader(() => import(/* webpackChunkName: "developer" */ './developer'));
export const PartnerApi = asyncLoader(() => import(/* webpackChunkName: "partner-api" */ './partner-api'));
export const Basic = asyncLoader(() => import(/* webpackChunkName: "basic" */ './basic'));
export const Admin = asyncLoader(() => import(/* webpackChunkName: "admin" */ './admin'));
export const Custom = asyncLoader(() => import(/* webpackChunkName: "custom" */ './custom'));

export const Home = asyncLoader(() => import(/* webpackChunkName: "home" */ './home'));
export const Sales = asyncLoader(() => import(/* webpackChunkName: "sales" */ './sales'));
export const Accounting = asyncLoader(() => import(/* webpackChunkName: "accounting" */ './accounting'));
export const Reports = asyncLoader(() => import(/* webpackChunkName: "reports" */ './reports'));
export const Projects = asyncLoader(() => import(/* webpackChunkName: "projects" */ './projects'));
export const Inventory = asyncLoader(() => import(/* webpackChunkName: "inventory" */ './inventory'));
export const Market = asyncLoader(() => import(/* webpackChunkName: "market" */ './market'));
export const JournalPro = asyncLoader(() => import(/* webpackChunkName: "journal-pro" */ './journal-pro'));
export const Settings = asyncLoader(() => import(/* webpackChunkName: "settings" */ './settings'));
export const User = asyncLoader(() => import(/* webpackChunkName: "user" */ './user'));

// Modules
export const Inbox = asyncLoader(() => import(/* webpackChunkName: "modules.inbox" */ './modules/inbox'));
export const Webshop = asyncLoader(() => import(/* webpackChunkName: "modules.webshop" */ './modules/webshop'));
export const WebshopPlus = asyncLoader(() => import(/* webpackChunkName: "modules.webshop-plus" */ './modules/webshop-plus'));
export const Website = asyncLoader(() => import(/* webpackChunkName: "modules.website" */ './modules/website'));
